/** Scroll homepage reg/VIN field into view and focus it (opens mobile keyboard on tap). */
export function goToLookup() {
  const section = document.getElementById("lookup");
  const input = document.getElementById("sl-vrm");
  section?.scrollIntoView({ behavior: "smooth", block: "center" });
  // Focus in the same user gesture so iOS/Android open the keyboard.
  if (input && !input.disabled) {
    input.focus({ preventScroll: true });
  }
}
